<div class="list">
  <div
    (click)="select(currency?.value)"
    class="item tappable hover"
    *ngFor="let currency of currencies"
  >
    <div class="row">
      <div class="col-1 padding-left-24 align-self-center">
        <mat-icon [svgIcon]="currency?.icon"></mat-icon>
      </div>

      <div class="col-8">
        <div class="d-flex flex-column">
          <p class="name mg-bottom-4">{{ currency?.description }}</p>
        </div>
      </div>

      <div class="col-2 d-flex align-items-center justify-content-center">
        <img src="assets/image/arrow-drawer.svg" />
      </div>
    </div>
  </div>
</div>
